import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: [],
  },
  getters: {
    ...functions.createDefaultGetters(["idDailyCounter"]),

    getAllByWork: (state, getters, rootState) => (workFilter) => {
      if (workFilter === "my") {
        return state.objs;
      } else {
        return state.objs.filter((e) => e.work == workFilter);
      }
    },
  },
  mutations: {
    ...functions.createDefaultMutations(["idDailyCounter"]),
  },
  actions: {
    ...functions.createDefaultActionsWithStore(["idDailyCounter"]),
  },
};
